import styled from 'styled-components';

export const Button = styled.button`
  cursor: pointer;
  flex: none;
`;

export const ButtonContainer = styled.div`
  display: flex;
  height: 100%;
`;
